import * as CalendarActionCreators from './calendarActions';
import * as DiaryActionCreators from './diaryActions';
import * as UserActionCreators from './userActions';
import * as PostPracticeActions from './postPracticeActions';
import * as CuratorialGroupActions from './curatorialGroupActions';
import * as PagesConfigActions from './pagesConfigActions';

export default {
    ...CalendarActionCreators,
    ...DiaryActionCreators,
    ...UserActionCreators,
    ...PostPracticeActions,
    ...CuratorialGroupActions,
    ...PagesConfigActions,
};